import { types } from "mobx-state-tree";

export enum FetchingEnum {
  DONE = "done",
  PENDING = "pending",
  ERROR = "error",
}

export const fetching = types.enumeration("fetching", [
  "pending",
  "done",
  "error",
]);
